import React, { useEffect } from 'react';
import { Radio, Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { renderIntlLabel } from '@/utils';
import { STATUS } from '../help';

import styles from './GoodSearch.module.scss';

function GoodSearch($$: {
  status: any;
  // keywords: string;
  onRadioChange: any;
  handleInputChange: any;
}) {
  useEffect(() => {}, []);

  return (
    <div className={styles.GoodSearch}>
      <div className={styles.leftBtns}>
        <Radio.Group
          className={styles.radioTab}
          options={STATUS}
          onChange={$$.onRadioChange}
          value={$$.status}
          optionType="button"
        />
      </div>
      <div className={styles.info}>
        <Input
          prefix={<SearchOutlined style={{ color: '#969799' }} />}
          type="search"
          allowClear
          placeholder={renderIntlLabel('goods_msg_please_input_goodsName')}
          style={{ width: 300 }}
          maxLength={200}
          onChange={$$.handleInputChange}
        />
      </div>
    </div>
  );
}

export default GoodSearch;
